import React from 'react';
import { HERO_MOCKUP_IMAGE } from '../../data/site';
export function BundleMockup() {
  return <figure className="mx-auto w-full max-w-[480px]" data-id="element-125" data-mp="1tpd5kfr8yu3w">
      <img src={HERO_MOCKUP_IMAGE} alt="Illustrative Handball Class Ready boxed set: 12 lessons and the five included digital bonuses" loading="lazy" width={1374} height={1145} className="block h-auto w-full drop-shadow-[0_12px_18px_rgba(7,28,51,0.15)]" data-id="element-126" data-mp="1tmr0cmrtwqou" />
      <figcaption className="mt-2 text-center text-xs text-slate-500" data-id="element-127" data-mp="15xfwgwf6mg6h">Illustrative mockup of the digital pack.</figcaption>
    </figure>;
}